export default "__VITE_ASSET__9fbu_0DY__"